module.exports = __webpack_public_path__ + "img/camiseta-cinza-costas.835faeb5.jpg";